import * as ProductLines from 'self-service-api/constants/ProductLines';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
export const getTrialUpgradeData = ({
  app,
  screen,
  productLine
}) => {
  const productLineToUpgradeProduct = {
    [ProductLines.MARKETING]: UpgradeProducts.MARKETING_PRO,
    [ProductLines.SALES]: UpgradeProducts.SALES_PROFESSIONAL
  };
  const upgradeData = {
    app,
    screen,
    uniqueId: app,
    upgradeProduct: productLineToUpgradeProduct[productLine],
    duration: 14
  };
  return upgradeData;
};